import React, { ReactElement } from "react";
import { Virtuoso } from "react-virtuoso";
import Typography from "@mui/material/Typography";

// TODO: Improve this implementation and replace React Window with it

function renderRow(index: number, item: ReactElement) {
	return (
		<Typography
			component="div"
			key={item.key}
			noWrap
		>
			{item}
		</Typography>
	);
}

const ReactVirtuosoListboxComponent = React.forwardRef<
	HTMLDivElement,
	React.HTMLAttributes<HTMLElement>
>((props, ref) => {
	const { children, ...other } = props;
	const itemData = React.Children.toArray(children);

	return (
		<span
			ref={ref}
			{...other}
		>
			<Virtuoso
				data={itemData}
				itemContent={renderRow}
				overscan={5}
				style={{
					width: "100%",
					minHeight: "400px",
					maxHeight: "40vh",
				}}
			/>
		</span>
	);
});

export default ReactVirtuosoListboxComponent;
